import Link from '@do/walrus/Link';
import { medium } from '@do/walrus/MediaQueries';
import colors from '@do/walrus/scss/core/_colors.scss';
import vars from '@do/walrus/scss/core/_variables.scss';
import Text from '@do/walrus/Text';
import React from 'react';
import styled from 'styled-components';
import logoFullSrc from '../assets/logo-full.svg';
import logoIconSrc from '../assets/logo-icon.svg';
import { FORCE_EXTERNAL, HEADER_HEIGHT } from '../constants';
import copy from '../copy';

const Container = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${HEADER_HEIGHT}px;
  padding-left: ${vars.space_5};
  padding-right: ${vars.space_5};
  background: ${colors.white};
  z-index: ${vars.z_index_raised};
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
`;

const Preamble = styled.span`
  display: none;
  margin-right: ${vars.space_3};
  font-size: ${vars.font_size_small};

  ${medium} {
    display: inline-block;
  }
`;

const DesktopLogo = styled.img.attrs(() => ({
  src: logoFullSrc
}))`
  display: none;

  ${medium} {
    display: block;
  }
`;
const MobileLogo = styled.img.attrs(() => ({
  src: logoIconSrc
}))`
  display: block;

  ${medium} {
    display: none;
  }
`;

interface Props {
  url?: string;
  isLogin?: boolean;
  forceExternal?: boolean;
  queryString?: string;
}

const Header: React.FC<Props> = ({
  isLogin,
  url = isLogin ? '/registrations/new' : '/login',
  forceExternal = false,
  queryString = ''
}) => {
  const text = isLogin ? copy.header.login : copy.header.register;

  return (
    <Container>
      <Link
        target="_self"
        includeContext={false}
        to="https://www.digitalocean.com"
      >
        <DesktopLogo />
        <MobileLogo />
      </Link>
      <Text>
        <Preamble>{text.preamble}</Preamble>
        <Link
          target="_self"
          includeContext={false}
          forceExternal={forceExternal || FORCE_EXTERNAL}
          to={url + queryString}
        >
          {text.link_text}
        </Link>
      </Text>
    </Container>
  );
};

export default Header;
